import { Paper, Stack, Avatar, Typography, Grid, Divider, Tooltip, Icon, Button,ButtonGroup, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FormDialog from "src/components/common/FormDialog";
import { alert } from "src/services/alert";
import IconInfo from "@mui/icons-material/Info";
import IconRefresh from "@mui/icons-material/Refresh";
import { asyncRequest } from "src/services/network";
import StoreIcon from "@mui/icons-material/Store";
import { LoadingButton } from "@mui/lab";

const wxApplyStatusMap = {
  APPLYMENT_STATE_EDITTING: "编辑中", // 可能在提交申请时发生错误导致，可用同一个业务申请编号重新提交
  APPLYMENT_STATE_WAITTING_FOR_AUDIT: "审核中", // 请耐心等待1~2个工作日，微信支付将会完成审核
  APPLYMENT_STATE_WAITTING_FOR_CONFIRM_CONTACT: "待确认联系信息", // 请扫描微信支付返回的小程序码确认联系信息(此过程可修改超级管理员手机号)
  APPLYMENT_STATE_WAITTING_FOR_CONFIRM_LEGALPERSON: "待账户验证", // 请扫描微信支付返回的小程序码在小程序端完成账户验证
  APPLYMENT_STATE_PASSED: "审核通过", // 请扫描微信支付返回的小程序码在小程序端完成授权流程
  APPLYMENT_STATE_REJECTED: "审核驳回", // 请按照驳回原因修改申请资料，并更换业务申请编码，重新提交申请
  APPLYMENT_STATE_CANCELED: "已作废", // 表示申请单已被撤销，无需再对其进行操作
  APPLYMENT_STATE_FREEZED: "已冻结", // 可能是该主体已完成过入驻，请查看驳回原因，并通知驳回原因中指定的联系人扫描微信支付返回的小程序码在小程序端完成授权流程
  APPLYMENT_STATE_NOAPPLY: "未申请",
};

const aliApplyStatusMap = {
  AUDITING: "审核中",
  CONTACT_CONFIRM: "待联系人确认",
  LEGAL_CONFIRM: "待法人确认",
  AUDIT_PASS: "审核通过",
  AUDIT_REJECT: "审核失败",
  AUDIT_FREEZE: "已冻结", // 本次申请冻结但仍会返回上次的授权码，可以扫码授权。
  CANCELED: "已撤回",
  NOT_APPLY: "未申请",
};

const statusMap = {
  Y: "审核通过",
  P: "审核中",
  N: "审核拒绝",
  F: "系统处理失败",
  C: "已撤销",
};

const ChannelDetailDialog = ({ merchant, open, onClose, onAuthWx, onAuthAli, onConfirmWxAuth, onConfirmAliAuth,onBtnFun, onFinish }) => {
  const { application, mid } = merchant;

  const [form, setForm] = useState({
    applyStatus: application ? application.applyStatus || "" : "", // 入驻状态
    wxApplyStatus: application ? application.wxApplyStatus || "" : "", // 微信实名状态
    aliApplyStatus: application ? application.aliApplyStatus || "" : "", // 支付宝实名状态
    agreementApplyStatus: application ? application.agreementApplyStatus || "" : "", // 协议
  });

  const [submitting, setSubmitting] = useState(false);

  function handleFormChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  let text = "";
  if (!application) {
    text = "点击入驻";
  } else {
    if (application.applyStatus != "Y") {
      text = "查询入驻审核状态";
    } else {
      if (!application.agreementApplyStatus) {
        text = "点击开通业务";
      } else if (application.agreementApplyStatus != "Y") {
        text = "查询签约状态";
      }
    }
  }
  const moreMenus = [
    {title: "开通三方支付"},
    {title: "开通业务"},
    {title: "微信实名认证"},
    {title: "支付宝实名认证"},
    {title: "重新入驻"},
    {title: "添加微信特约商户appid"},

  ];
  // 入驻
  async function onApplyHuifu() {
    try {
      if (submitting) return alert("慢点！！！");
      setSubmitting(true);
      const { msg } = await asyncRequest({
        path: "/merchant/huifu/apply",
        data: {
          mid,
          reEnter: false,
        },
        complete() {
          setTimeout(() => {
            setSubmitting(false);
          }, 5000);
        },
      });

      alert(msg, "success");
      onFinish();
    } catch (error) {
      setTimeout(() => {
        setSubmitting(false);
      }, 5000);
    }
  }
  async function handleMenuClick(type) {
    onBtnFun(type,merchant)
  }
  async function onConfirm() {
    const { data } = await asyncRequest({
      path: "/merchant/huifu/edit",
      data: {
        mid,
        ...form,
      },
    });

    onFinish();
    onClose();
  }

  return (
    <FormDialog title="汇付①商户配置" open={open} onClose={onClose} onConfirm={onConfirm}>
      <Stack sx={{ minWidth: 600 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2">注册名称：{merchant.licenseName}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">商户简称：{merchant.name}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">联系电话：{merchant.mobile}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">
              汇付ID：{merchant.hfUid}
              {!!text && (
                <LoadingButton disabled={submitting} loading={submitting} loadingPosition="start" startIcon={<StoreIcon />} variant="outlined" onClick={onApplyHuifu}>
                  {text}
                </LoadingButton>
              )}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ marginY: 2 }} />

        {!!application && (
          <>
            <Grid container spacing={1}>
              {application.wxApplyStatus ? (
                <>
                  <Grid item xs={6}>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Typography variant="body2">微信认证状态：{wxApplyStatusMap[application.wxApplyStatus]}</Typography>
                      <Tooltip title={application.wxMsg}>
                        <IconInfo fontSize="14" />
                      </Tooltip>
                      <IconRefresh fontSize="14" onClick={() => onAuthWx(merchant.mid)} />
                      <Button variant="text" onClick={onConfirmWxAuth}>
                        手动确认完成
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2">子商户号：{application.wxMid}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2">认证二维码：</Typography>
                    {application && application.wxQrData && <img src={`data:image/jpg;base64,${application.wxQrData}`} style={{ maxWidth: 300 }} />}
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2"></Typography>
                  </Grid>
                </>
              ) : (
                <Grid item xs={6}>
                  <Typography variant="body2" onClick={() => onAuthWx(merchant.mid)}>
                    点击认证微信
                  </Typography>
                </Grid>
              )}
            </Grid>

            <Divider sx={{ marginY: 2 }} />

            <Grid container spacing={1}>
              {application.aliApplyStatus ? (
                <>
                  <Grid item xs={6}>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Typography variant="body2">支付宝认证状态：{aliApplyStatusMap[application.aliApplyStatus]}</Typography>
                      <Tooltip title={application.aliMsg}>
                        <IconInfo fontSize="14" />
                      </Tooltip>
                      <IconRefresh fontSize="14" onClick={() => onAuthAli(merchant.mid)} />
                      <Button variant="text" onClick={onConfirmAliAuth}>
                        手动确认完成
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2">子商户号：{application.aliMid}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2">认证二维码：</Typography>
                    {application && application.aliQrData && <img src={application.aliQrData} style={{ maxWidth: 300 }} />}
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2"></Typography>
                  </Grid>
                </>
              ) : (
                <Grid item xs={6}>
                  <Typography variant="body2" onClick={() => onAuthAli(merchant.mid)}>
                    点击认证支付宝
                  </Typography>
                </Grid>
              )}
            </Grid>

            <Divider sx={{ marginY: 2 }} />
          </>
        )}
        <Grid container spacing={1}>
          <Stack direction="row" sx={{ marginTop: 2,marginBottom:1 }}>
            <ButtonGroup variant="outlined" aria-label="outlined button group">
              {moreMenus.map((menu, i) => {
                const { title, icon } = menu;
                return (
                  <Button key={i} onClick={() => handleMenuClick(title)}>
                    {title}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Stack>
        </Grid>
        <Divider sx={{ marginY: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography fontSize={14}>如有同步问题，可以手动设置审核状态</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="applyStatus">入驻审核状态</InputLabel>
              <Select labelId="applyStatus" id="demo-simple-select" value={form.applyStatus} label="入驻审核状态" onChange={(e) => handleFormChange("applyStatus", e.target.value)}>
                {Object.keys(statusMap).map((k) => (
                  <MenuItem value={k}>{statusMap[k]}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="agreementApplyStatus">签约状态</InputLabel>
              <Select labelId="agreementApplyStatus" id="demo-simple-select" value={form.agreementApplyStatus} label="签约状态" onChange={(e) => handleFormChange("agreementApplyStatus", e.target.value)}>
                {Object.keys(statusMap).map((k) => (
                  <MenuItem value={k}>{statusMap[k]}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="wxApplyStatus">微信实名状态</InputLabel>
              <Select labelId="wxApplyStatus" id="demo-simple-select" value={form.wxApplyStatus} label="微信实名状态" onChange={(e) => handleFormChange("wxApplyStatus", e.target.value)}>
                {Object.keys(wxApplyStatusMap).map((k) => (
                  <MenuItem value={k}>{wxApplyStatusMap[k]}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="aliApplyStatus">支付宝实名状态</InputLabel>
              <Select labelId="aliApplyStatus" id="demo-simple-select" value={form.aliApplyStatus} label="支付宝实名状态" onChange={(e) => handleFormChange("aliApplyStatus", e.target.value)}>
                {Object.keys(aliApplyStatusMap).map((k) => (
                  <MenuItem value={k}>{aliApplyStatusMap[k]}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Stack>
    </FormDialog>
  );
};

export default ChannelDetailDialog;
